"use client";

import React, { createContext, useContext, useState } from "react";

type MetaDataType = Record<string, any>;

interface MetaDataContextType {
  metaData: MetaDataType;
  updateMetaData: (newData: MetaDataType) => void;
  resetMetaData: () => void;
  replaceMetaData:(newData: MetaDataType) => void;
}

const MetaDataContext = createContext<MetaDataContextType | undefined>(undefined);

export const MetaDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [metaData, setMetaData] = useState<MetaDataType>({});

  const updateMetaData = (newData: MetaDataType) => {
    setMetaData((prev) => ({
        ...prev,
        ...newData,
    }));
  };

  const replaceMetaData = (newData: MetaDataType) => {
  setMetaData({ ...newData });
};

  const resetMetaData = () => {
    setMetaData({});
  };

  return (
    <MetaDataContext.Provider value={{ metaData, updateMetaData, resetMetaData ,replaceMetaData}}>
      {children}
    </MetaDataContext.Provider>
  );
};

// Custom hook for accessing the context
export const useMetaData = () => {
  const context = useContext(MetaDataContext);
  if (!context) {
    throw new Error("useMetaData must be used within a MetaDataProvider");
  }
  return context;
};
